import { KeyframeConfig } from "../../../models/animations.model";

const WIPE_SCALE_BUFFER = 1.2;
const WIPE_OFFSET_BUFFER = -16;

export const getWipeInLeftBaseKeyframe = (
  left: number,
  width: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left: left - width * WIPE_SCALE_BUFFER,
          },
          {
            left: left,
          },
        ],
      },
      offset: WIPE_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeInRightBaseKeyframe = (
  left: number,
  width: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left: left + width * WIPE_SCALE_BUFFER,
          },
          {
            left,
          },
        ],
      },
      offset: WIPE_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeInTopBaseKeyframe = (
  top: number,
  height: number,
  fabricObject: any,
  duration: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: top - height * WIPE_SCALE_BUFFER,
          },
          {
            top,
          },
        ],
      },
      offset: WIPE_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeInBottomBaseKeyframe = (
  top: number,
  height: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: top + height * WIPE_SCALE_BUFFER,
          },
          {
            top: top,
          },
        ],
      },
      offset: WIPE_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeOutLeftBaseKeyframe = (
  left: number,
  width: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left,
          },
          {
            left: left - width,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeOutRightBaseKeyframe = (
  left: number,
  width: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left,
          },
          {
            left: left + width,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeOutTopBaseKeyframe = (
  top: number,
  height: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: top,
          },
          {
            top: top - height,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};

export const getWipeOutBottomBaseKeyframe = (
  top: number,
  height: number,
  fabricObject: any
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: top,
          },
          {
            top: top + height,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 1,
          },
          {
            opacity: 1,
          },
        ],
      },
    },
  ];
};
